import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Activity = lazy(() => import('./activity.component'));

export function ActivityRoutes() {
    return (
        <Route path='activities'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <Activity />
                    </AsyncComponent>
                }
            />
        </Route>
    );
}
